class QuickAddModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onClickInside = this.onClickInside.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.animateFollow = this.animateFollow.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
    this.mouseX = 0;
    this.mouseY = 0;
    this.floatingX = 0;
    this.floatingY = 0;
    this.raf = null;
    this.mediaQuery = window.matchMedia(
      "(pointer: fine) and (min-width: 990px) and (prefers-reduced-motion: no-preference)"
    );
    this.dynamicEnabled = false;
    document.body.appendChild(this);
    window.addEventListener("resize", () => {
      this.modalContent
        .querySelectorAll(".js-media-list")
        .forEach((element) => {
          element.swiper?.destroy();
        });
      setTimeout(() => {
        sliderInit(this.modalContent, true);
      }, 200);
    });
  }
  show(opener, event) {
    this.isOpen = true;
    opener.setAttribute("aria-disabled", true);
    opener.classList.add("loading");
    const spinner = opener.querySelector(".loading-overlay__spinner");
    if (spinner) {
      spinner.classList.remove("hidden");
    }
    fetch(opener.getAttribute("data-product-url"))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        this.productElement = responseHTML.querySelector(
          'section[id^="MainProduct-"]'
        );
        this.dialogEl = this.querySelector('[role="dialog"]');
        this.closeButton = this.querySelector('[id^="ModalClose-"]');
        this.closeButton?.addEventListener("click", this.onCloseClick);
        this.addEventListener("keyup", this.onKeyUp);
        this.addEventListener("click", this.onClickInside);
        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.setInnerHTML(this.modalContent, this.productElement, opener);
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) window.ProductModel.loadShopifyXR();
        this.updateImageSizes();
        this.preventVariantURLSwitching();
        setTimeout(() => {
          this.classList.add("active");
        });
        this.openedBy = opener;
        this.setAttribute("open", "");
        document.body.classList.add("overflow-hidden");
        trapFocus(this, this.dialogEl);
        window.pauseAllMedia?.();
        this.mediaQuery.addEventListener("change", this.onMediaChange);
        this.onMediaChange(this.mediaQuery);
        if (event && this.dynamicEnabled) {
          this.instantPositionCloseButton(event);
        }
        this.addEventListener(
          "transitionend",
          () => {
            const containerToTrapFocusOn = this;
            const focusElement = this.querySelector(
              ".quick-add-modal__content"
            );
            trapFocus(containerToTrapFocusOn, focusElement);
          },
          { once: true }
        );
      })
      .finally(() => {
        opener.removeAttribute("aria-disabled");
        opener.classList.remove("loading");
        if (opener.querySelector(".loading-overlay__spinner")) {
          opener
            .querySelector(".loading-overlay__spinner")
            .classList.add("hidden");
        }
        this.modalContent
          .querySelectorAll(".js-media-list")
          .forEach((element) => {
            element.swiper?.destroy();
          });
        sliderInit(this.modalContent, true);
        this.initProductAccordion();
        this.setScrollClass(this.modalContent);
      });
  }
  hide(preventFocus = false) {
    this.isOpen = false;
    this.classList.add("closing");
    setTimeout(() => {
      this.modalContent.innerHTML = "";
      this.modalContent.querySelectorAll(".js-media-list").forEach(function () {
        this.swiper?.destroy();
      });
      sliderInit(this.modalContent, true);
      if (preventFocus) this.openedBy = null;
      this.classList.remove("active");
      this.removeAttribute("open");
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia?.();
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      this._disableDynamic();
      this.mediaQuery.removeEventListener("change", this.onMediaChange);
      const mediaContent = document.querySelector(
        ".product-media-modal__content"
      );
      if (mediaContent) {
        mediaContent.classList.remove("zoom");
      }
      this.classList.remove("closing");
    }, 250);
    this.addEventListener(
      "transitionend",
      () => {
        this.openedBy
          ?.closest(".card__links")
          .nextElementSibling.focus({ preventScroll: true });
      },
      { once: true }
    );
  }
  setInnerHTML(element, html, opener) {
    const mediaSublist = html.querySelector(".product-media-sublist-outer");
    if (mediaSublist) {
      mediaSublist.remove();
    }
    element.innerHTML = html.innerHTML;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
    const moreBtn = document.createElement("a");
    moreBtn.innerHTML = `<span>${theme.quickviewMore}</span>`;
    moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
    moreBtn.setAttribute(
      "class",
      "product-full-details button button--underline"
    );
    const infoContainer = element.querySelector(".product-info-container");
    if (!infoContainer) return;
    infoContainer.appendChild(moreBtn);
  }
  toggleScrollClass(element) {
    const productOuter = element?.querySelector(".product-outer");
    if (!productOuter) return;
    const visibleHeight =
      this.querySelector(".quick-add-modal__content").getBoundingClientRect()
        .height - 48;
    if (productOuter.scrollHeight > visibleHeight) {
      element.classList.add("has-scroll");
    } else {
      element.classList.remove("has-scroll");
    }
  }
  calcHeight() {
    const mediaAspectRatio =
      this.querySelector(".product-media").getAttribute("data-image-type");
    if (mediaAspectRatio === "landscape") {
      this.style.setProperty(
        "--image-height",
        "var(--image-height--landscape)"
      );
    }
    if (mediaAspectRatio === "portrait") {
      this.style.setProperty("--image-height", "var(--image-height--portrait)");
    }
    if (mediaAspectRatio === "square") {
      this.style.setProperty("--image-height", "var(--image-height--square)");
    }
  }
  setScrollClass(element) {
    const resizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      const dialog = entry.target.querySelector(
        ".quick-add-modal__content-info"
      );
      if (dialog && this.isOpen) {
        this.calcHeight();
        this.toggleScrollClass(dialog);
      }
    });
    if (element) {
      resizeObserver.observe(this);
    }
  }
  initProductAccordion() {
    const toggles = this.querySelectorAll(".product-dropdown__toggle");
    toggles.forEach((toggle) => {
      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        const description = toggle.nextElementSibling?.classList.contains(
          "product-dropdown__content"
        )
          ? toggle.nextElementSibling
          : toggle.previousElementSibling?.classList.contains(
              "product-dropdown__content"
            )
          ? toggle.previousElementSibling
          : null;
        if (description) {
          if (!toggle.classList.contains("active")) {
            slideDown(toggle, description, 300); // func in global.js
          } else {
            slideUp(toggle, description, 300); // func in global.js
          }
        }
      });
    });
  }
  removeDOMElements() {
    const selectors = [
      ".pickup-availability",
      ".share-buttons",
      ".product-popup",
      ".complementary-products",
      "product-modal",
    ];
    selectors.forEach((selector) => {
      this.productElement
        .querySelectorAll(selector)
        .forEach((el) => el.remove());
    });
  }
  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
      sectionId,
      `quickadd-${sectionId}`
    );
    this.productElement
      .querySelectorAll("variant-radios")
      .forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
  }
  preventVariantURLSwitching() {
    if (this.modalContent.querySelector("variant-radios")) {
      this.modalContent
        .querySelector("variant-radios")
        .setAttribute("data-update-url", "false");
    }
  }
  updateImageSizes() {
    const productMedia = this.modalContent.querySelector(".product-media");
    if (!productMedia) return;
    const productMediaList =
      productMedia.querySelector(".product-media__list.js-media-list") ||
      productMedia.querySelector(".product-media__list");
    if (!productMediaList) return;
    const mediaImages = productMediaList.querySelectorAll(
      ".product__media img"
    );
    if (!mediaImages.length) return;
    const aspectRatio =
      productMedia.getAttribute("data-image-type") || "square";
    let mediaRatio = 1;
    switch (aspectRatio) {
      case "landscape":
        mediaRatio = 1.33;
        break;
      case "portrait":
        mediaRatio = 0.76;
        break;
      case "square":
        mediaRatio = 1;
        break;
      default:
        mediaRatio = 1;
        break;
    }
    mediaImages.forEach((img) => {
      const imgAspectRatio =
        img.getAttribute("width") / img.getAttribute("height");
      let calcRatio = 1;
      if (imgAspectRatio > mediaRatio) {
        calcRatio = +(imgAspectRatio / mediaRatio).toFixed(2);
      }
      const mediaImageSizes = `(min-width: 1360px) calc(${calcRatio} * 512px), (min-width: 1200px) calc(${calcRatio} * 456px), (min-width: 990px) calc(${calcRatio} * 414px), (min-width: 576px) calc(${calcRatio} * 95vw), calc(${calcRatio} * 100vw - 4rem)`;
      img.setAttribute("sizes", mediaImageSizes);
    });
  }
  onCloseClick(e) {
    e.stopPropagation();
    if (!this.closeButton) {
      return this.hide();
    }
    this.closeButton.classList.add("pulse");
    this.hide();
    const done = () => {
      this.closeButton.removeEventListener("animationend", done);
      this.closeButton.classList.remove("pulse");
    };
    this.closeButton.addEventListener("animationend", done);
  }
  disconnectedCallback() {
    this.closeButton?.removeEventListener("click", this.onCloseClick);
    this.removeEventListener("keyup", this.onKeyUp);
    this.removeEventListener("click", this.onClickInside);
    this._disableDynamic();
    this.mediaQuery.removeEventListener("change", this.onMediaChange);
  }
  instantPositionCloseButton(event) {
    if (!this.closeButton) return;
    const offsetX = 32,
      offsetY = 32;
    this.mouseX = event.clientX - offsetX;
    this.mouseY = event.clientY - offsetY;
    this.floatingX = this.mouseX;
    this.floatingY = this.mouseY;
    Object.assign(this.closeButton.style, {
      position: "fixed",
      zIndex: "9999",
      left: `${this.floatingX}px`,
      top: `${this.floatingY}px`,
      pointerEvents: "none",
    });
    const content = this.querySelector(".quick-add-modal__content");
    if (content) {
      const rect = content.getBoundingClientRect();
      const inside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (inside) {
        this.classList.remove("cursor-active");
      } else {
        this.classList.add("cursor-active");
      }
    }
  }
  onMediaChange(e) {
    if (e.matches && !this.dynamicEnabled) {
      this.dynamicEnabled = true;
      document.addEventListener("mousemove", this.onMouseMove);
      this.raf = requestAnimationFrame(this.animateFollow);
    } else if (!e.matches && this.dynamicEnabled) {
      this._disableDynamic();
    }
  }
  _disableDynamic() {
    if (!this.dynamicEnabled) return;
    document.removeEventListener("mousemove", this.onMouseMove);
    cancelAnimationFrame(this.raf);
    this.dynamicEnabled = false;
    if (this.closeButton) {
      this.closeButton.style.position = "";
      this.closeButton.style.left = "";
      this.closeButton.style.top = "";
      this.closeButton.style.pointerEvents = "";
      this.closeButton.style.zIndex = "";
      this.classList.remove("cursor-active");
    }
  }
  onMouseMove(event) {
    if (!this.closeButton) return;
    const offsetX = 32,
      offsetY = 32;
    this.mouseX = event.clientX - offsetX;
    this.mouseY = event.clientY - offsetY;
    if (!event.target.closest(".quick-add-modal__content")) {
      this.classList.add("cursor-active");
    } else {
      this.classList.remove("cursor-active");
    }
  }
  animateFollow() {
    if (!this.closeButton) return;
    const ease = 0.25;
    this.floatingX += (this.mouseX - this.floatingX) * ease;
    this.floatingY += (this.mouseY - this.floatingY) * ease;
    Object.assign(this.closeButton.style, {
      position: "fixed",
      zIndex: "9999",
      left: `${this.floatingX}px`,
      top: `${this.floatingY}px`,
      pointerEvents: "none",
    });
    this.raf = requestAnimationFrame(this.animateFollow);
  }
  onKeyUp(event) {
    if (event.code === "Escape") {
      this.hide();
    }
  }
  onClickInside(event) {
    if (!event.target.closest(".quick-add-modal__content")) {
      this.onCloseClick(event);
    }
  }
  onCloseClick(e) {
    e.stopPropagation();
    if (!this.closeButton) {
      return this.hide();
    }
    this.closeButton.classList.add("pulse");
    this.hide();
    const done = () => {
      this.closeButton.removeEventListener("animationend", done);
      this.closeButton.classList.remove("pulse");
    };
    this.closeButton.addEventListener("animationend", done);
  }
}
if (!customElements.get("quick-add-modal")) {
  customElements.define("quick-add-modal", QuickAddModal);
}
